import React from 'react'
import Main from '../components/admin/Main'
import PageContainer from '../components/admin/PageContainer';
import { Feather, Link } from 'react-feather';

const Dashboard = ({onLogout}) => {

  return (
    <Main>
      <PageContainer>
        <div className='d-flex align-items-center justify-content-between'>
          <h1>Welcome to the Administrative portal </h1>
          {/* <button className='btn btn-primary d-inline-block' onClick={onLogout}>Logout</button> */}
        </div>
        
      </PageContainer>
    </Main>
  );
}

export default Dashboard;